import React from 'react';
const SvgXlsx = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M43 44H13V4h21l9 9z" />
      <path fill="#949494" d="M34 3H12v42h32V13L34 3zm0 1.5l8.5 8.5H34V4.5zM43 44H13V4h20v10h10v30z" />
      <path fill="#217346" d="M4 17l20-3v26L4 37z" />
      <path
        fill="#FFF"
        d="M20 33h-3.458l-2.23-3.908c-.085-.145-.172-.413-.262-.803h-.036a5.802 5.802 0 01-.298.837L11.476 33H8l4.126-6-3.774-6h3.549l1.85 3.598c.145.285.274.622.389 1.013h.036c.072-.234.208-.583.406-1.046L16.642 21h3.25l-3.883 5.95L20 33z"
      />
      <path
        fill="#C8C8C8"
        d="M33 17h7v2h-7zM24 17h7v2h-7zM33 21h7v2h-7zM24 21h7v2h-7zM33 25h7v2h-7zM24 25h7v2h-7zM33 29h7v2h-7zM24 29h7v2h-7zM33 33h7v2h-7zM24 33h7v2h-7zM33 37h7v2h-7zM24 37h7v2h-7z"
      />
      <linearGradient id="xlsx_svg__a" gradientUnits="userSpaceOnUse" x1={8.587} y1={5.864} x2={42.489} y2={46.268}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#xlsx_svg__a)" d="M44 13L34 3H12v42h32V13z" />
      <linearGradient id="xlsx_svg__b" gradientUnits="userSpaceOnUse" x1={38} y1={16.906} x2={38} y2={14.088}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#xlsx_svg__b)" d="M33 14h10v3H33z" />
      <linearGradient id="xlsx_svg__c" gradientUnits="userSpaceOnUse" x1={31.27} y1={12.23} x2={37.236} y2={6.264}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#xlsx_svg__c)" d="M12 3v1h21v10h10v14h1V13L34 3z" />
      <linearGradient id="xlsx_svg__d" gradientUnits="userSpaceOnUse" x1={14} y1={39.188} x2={14} y2={14.758}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.859} stopColor="#fff" stopOpacity={0.155} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.18} />
      </linearGradient>
      <path fill="url(#xlsx_svg__d)" d="M24 14L4 17v20l20 3z" />
      <linearGradient id="xlsx_svg__e" gradientUnits="userSpaceOnUse" x1={17.754} y1={42.918} x2={18.177} y2={38.93}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.17} stopColor="#7e7e7e" stopOpacity={0.034} />
        <stop offset={0.346} stopColor="#717171" stopOpacity={0.069} />
        <stop offset={0.525} stopColor="#5d5d5d" stopOpacity={0.105} />
        <stop offset={0.706} stopColor="#404040" stopOpacity={0.141} />
        <stop offset={0.886} stopColor="#1b1b1b" stopOpacity={0.178} />
        <stop offset={0.997} stopOpacity={0.2} />
      </linearGradient>
      <path fill="url(#xlsx_svg__e)" d="M24 43H12v-4.8L24 40z" />
    </svg>
  );
});
export default SvgXlsx;
SvgXlsx.iconName = 'xlsx';
SvgXlsx.displayName = 'SvgXlsx';
